import { SlideRoot } from '@/modules/education/EducationSlideTrowser/components/SlideRoot';

import { BLOCK_EDITOR_RESOLVER } from '../BlockEditor.utils';
import { EditableCallout } from './EditableCallout/EditableCallout';
import { EditableEducationalSlideBody } from './EducationalSlideBodyText/EditableEducationalSlideBody';
import { EducationalSlideHeading } from './EducationalSlideHeading/EducationalSlideHeading';
import { EditablePresentationListItem } from './PresentationListItem/EditablePresentationListItem';

/**
 * CraftJS resolver for education slides.
 * Extends the base block editor resolver with education-slide-specific components.
 */
export const EDUCATION_SLIDE_RESOLVER = {
  ...BLOCK_EDITOR_RESOLVER,
  // Content blocks
  PresentationListItem: EditablePresentationListItem,
  EducationalSlideHeading: EducationalSlideHeading,
  EditableEducationalSlideBody: EditableEducationalSlideBody,
  EditableCallout: EditableCallout,
  // Root
  SlideRoot: SlideRoot,
};
